import Link from "./Link";

const FooterLink = ({ to, label }: { to: string; label: string }) => (
  <div className="h-24 flex justify-center items-center text-secondary">
    <Link to={to} label={label} />
  </div>
);

export default FooterLink;
